let last: string | null = null

export function newRequestId(): string {
  return crypto.randomUUID()
}

export function setLastRequestId(id: string | null): void {
  last = id
}

/** ID последнего запроса, завершившегося ошибкой. Уходит в тост и в экран смерти. */
export function lastRequestId(): string | null {
  return last
}
